import axios from 'axios';
import Cookies from 'js-cookie';

const baseURL = 'https://share.anthonybois.fr/api.php';

export const apiCall = async (endpoint, params = {}, post = false, method = 'POST') => {
  try {
    // Ajouter le token aux paramètres si on a un userId
    if (params.user_id) {
      const token = Cookies.get('userToken');
      if (token) {
        params.token = token;
      }
    }

    let response;
    if (post) {
      if (method === 'DELETE') {
        response = await axios.delete(`${baseURL}?i=${endpoint}`, { data: params });
      } else if (method === 'PUT') {
        response = await axios.put(`${baseURL}?i=${endpoint}`, params);
      } else {
        response = await axios.post(`${baseURL}?i=${endpoint}`, params);
      }
    } else {
      response = await axios.get(`${baseURL}?i=${endpoint}`, { params });
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};